import { businessErrorFactory, BusinessError } from '../../../../../../../common/business-error';

import { BUSINESS_ERRORS } from './interfaces';

const EDIT_ACCOUNT_INFORMATION_UNEXPECTED_ERROR =
  // eslint-disable-next-line max-len
  'Sorry we ran into an unexpected error and OTP could not be send. Please try again. If the problem still persists, contact with support.';

const MSISDN_ALREADY_USED = 'This phone number is already in use. Please try the different one.';

const INCORRECT_MSISDN =
  'Sorry but this phone number is incorrect and could not be handled. Please try the different one.';

const OTP_DELIVERY_FAILURE =
  // eslint-disable-next-line max-len
  'Sorry we ran into an unexpected error and OTP could not be delivered. Please try again. If the problem still persists, contact with support.';

export const getEditAccountBusinessError = (businessError: unknown): BusinessError => {
  switch (businessError) {
    case BUSINESS_ERRORS.MSISDN_ALREADY_USED: {
      return businessErrorFactory({ message: MSISDN_ALREADY_USED, severity: 'warning' });
    }
    case BUSINESS_ERRORS.INCORRECT_MSISDN: {
      return businessErrorFactory({ message: INCORRECT_MSISDN, severity: 'warning' });
    }
    case BUSINESS_ERRORS.OTP_DELIVERY_FAILURE: {
      return businessErrorFactory({ message: OTP_DELIVERY_FAILURE, severity: 'error' });
    }
    default: {
      return businessErrorFactory({
        message: EDIT_ACCOUNT_INFORMATION_UNEXPECTED_ERROR,
        severity: 'error'
      });
    }
  }
};

const OTP_VERIFICATION_UNEXPECTED_ERROR =
  // eslint-disable-next-line max-len
  'Sorry we ran into an unexpected error and your profile could not be updated. Please try again. If the problem still persists, contact with support.';

const INCORRECT_OTP = 'Your OTP codes do not match. Please try again.';

const MISSING_OTP =
  "Sorry we didn't received your OTP. Please try again. If the problem still persists, contact with support.";

const ORDER_NOT_FOUND =
  // eslint-disable-next-line max-len
  'Sorry we ran into an error while processing your settings and your profile could not be updated. Please try again. If the problem still persists, contact with support.';

const OTP_EXPIRED =
  'Your OTP codes expired. Please go back to the settings and repeat the operation from the beginning.';

const SERVER_DOES_NOT_RESPOND = 'Server does not respond. Please report this to administrator.';

const OTP_COULD_NOT_BE_SEND =
  // eslint-disable-next-line max-len
  'Sorry we ran into an unexpected error and OTP could not be send. Please try again. If the problem still persists, contact with support.';

const getOtpExhaustedLimitMsg = (duration: number) =>
  `Sorry, but you have reached the limit of OTP requests, please wait ${duration} seconds and try again if necessary.`;

export const getOtpVerifyBusinessError = (businessError: unknown, apiParams?: Record<string, any>): BusinessError => {
  switch (businessError) {
    case BUSINESS_ERRORS.INCORRECT_OTP: {
      return businessErrorFactory({ message: INCORRECT_OTP, severity: 'warning' });
    }
    case BUSINESS_ERRORS.OTP_EXHAUSTED_LIMIT: {
      return businessErrorFactory({
        message: getOtpExhaustedLimitMsg(apiParams?.duration),
        severity: 'warning'
      });
    }
    case BUSINESS_ERRORS.MISSING_OTP: {
      return businessErrorFactory({ message: MISSING_OTP, severity: 'warning' });
    }
    case BUSINESS_ERRORS.ORDER_NOT_FOUND: {
      return businessErrorFactory({ message: ORDER_NOT_FOUND, severity: 'error' });
    }
    case BUSINESS_ERRORS.OTP_EXPIRED: {
      return businessErrorFactory({ message: OTP_EXPIRED, severity: 'warning' });
    }
    case BUSINESS_ERRORS.OTP_COULD_NOT_BE_SEND: {
      return businessErrorFactory({ message: OTP_COULD_NOT_BE_SEND, severity: 'error' });
    }
    case BUSINESS_ERRORS.SERVER_DOES_NOT_RESPOND: {
      return businessErrorFactory({ message: SERVER_DOES_NOT_RESPOND, severity: 'error' });
    }
    default: {
      return businessErrorFactory({
        message: OTP_VERIFICATION_UNEXPECTED_ERROR,
        severity: 'error'
      });
    }
  }
};
